import { MdNavigateNext, MdVisibility } from "react-icons/md";
import { FaLongArrowAltLeft, FaLongArrowAltRight } from "react-icons/fa";
import { HiViewGrid } from "react-icons/hi";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getPosts } from "../../redux/features/post/postSlice";

const DropDownTwo = () => {
  const [allCat, setAllCat] = useState(false);
  const [usCanadaCat, setUsCanadaCat] = useState(false);
  const [africaCat, setAfricaCat] = useState(false);
  const [middleEastCat, setMiddleEastCat] = useState(false);
  const [europeCat, setEuropeCat] = useState(false);

  const handleAllCat = (e) => {
    setAllCat(true);
    setUsCanadaCat(false);
    setAfricaCat(false);
    setMiddleEastCat(false);
    setEuropeCat(false);
  };

  const handleUsCanadaCat = (e) => {
    setAllCat(false);
    setUsCanadaCat(true);
    setAfricaCat(false);
    setMiddleEastCat(false);
    setEuropeCat(false);
  };

  const handleAfricaCat = (e) => {
    setAllCat(false);
    setUsCanadaCat(false);
    setAfricaCat(true);
    setMiddleEastCat(false);
    setEuropeCat(false);
  };

  const handleMiddleEastCat = (e) => {
    setAllCat(false);
    setUsCanadaCat(false);
    setAfricaCat(false);
    setMiddleEastCat(true);
    setEuropeCat(false);
  };

  const handleEuropeCat = (e) => {
    setAllCat(false);
    setUsCanadaCat(false);
    setAfricaCat(false);
    setMiddleEastCat(false);
    setEuropeCat(true);
  };

  useEffect(() => {
    setAllCat(true);
  }, [setAllCat]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch]);
  const { posts } = useSelector((state) => state.post);

  const allCategory = posts
    ?.filter((post) => {
      return post.category === "World News";
    })
    ?.filter((post, index) => index < 4);

  const africa = posts
    ?.filter((post) => {
      return post.type === "Africa";
    })
    ?.filter((post, index) => index < 4);

  return (
    <div className="dropDownMenu2">
      <div className="dropDownMenu2Wrapper">
        <div className="left">
          <div className="item" onMouseEnter={handleAllCat}>
            <span>All</span>
            <MdNavigateNext size={20} />
          </div>
          <div className="item" onMouseEnter={handleUsCanadaCat}>
            <span>US & Canada</span>
            <MdNavigateNext className="fa" size={20} />
          </div>
          <div className="item" onMouseEnter={handleAfricaCat}>
            <span>Africa</span>
            <MdNavigateNext className="fa" size={20} />
          </div>
          <div className="item" onMouseEnter={handleMiddleEastCat}>
            <span>Middle East</span>
            <MdNavigateNext className="fa" size={20} />
          </div>
          <div className="item" onMouseEnter={handleEuropeCat}>
            <span>Europe</span>
            <MdNavigateNext className="fa" size={20} />
          </div>
        </div>

        <div className="right">
          {allCat && (
            <div className="rightTop">
              {allCategory.map((news) => {
                return (
                  <div className="item" key={news._id}>
                    <div className="img">
                      <Link to={`/page/${news._id}`}>
                        <img src={news.image[0]} alt="" />
                      </Link>
                      <Link className="cat">{news.type}</Link>
                      <Link className="icon">
                        <MdVisibility size={20} />
                      </Link>
                    </div>
                    <Link to={`/page/${news._id}`} className="title">
                      It is a lone established fact that a reader will be
                      distracted by
                    </Link>
                  </div>
                );
              })}
            </div>
          )}

          {africaCat && (
            <div className="rightTop">
              {africa.map((news) => {
                return (
                  <div className="item" key={news._id}>
                    <div className="img">
                      <Link to={`/page/${news._id}`}>
                        <img src={news.image[0]} alt="" />
                      </Link>
                      <Link className="cat">{news.type}</Link>
                      <Link className="icon">
                        <MdVisibility size={20} />
                      </Link>
                    </div>
                    <Link to={`/page/${news._id}`} className="title">
                      It is a lone established fact that a reader will be
                      distracted by
                    </Link>
                  </div>
                );
              })}
            </div>
          )}

          <div className="rightBottom">
            <Link className="prev" title="Previous">
              <FaLongArrowAltLeft size={18} />
            </Link>
            <Link className="all" title="View All">
              <HiViewGrid size={18} />
            </Link>
            <Link className="next" title="Next">
              <FaLongArrowAltRight size={18} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DropDownTwo;
